const colors = {
	primaryColor: '#00b0ff',
	afterSortingColor: '#00587a',
	pivotActiveColor: '#ff2400',
	sortedElementColor: '#4cbb17',
	cyan: '#40E0D0',
	orange: '#FFA500',
};

export default colors;
